<script setup lang="ts">
const { accentColor } = defineProps<{
    accentColor: string;
}>();

const emit = defineEmits<{
    dismiss: [];
}>();
</script>

<template>
    <button type="button" class="rounded-full" @click="emit('dismiss')">
        <span class="sr-only">Dismiss</span>
        <svg
            class="size-5 fill-current"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
            />
        </svg>
    </button>
</template>

<style scoped>
button {
    color: v-bind(accentColor);
}

button:hover {
    color: color-mix(in srgb, v-bind("accentColor") 90%, transparent);
}

button:focus-visible {
    outline: 2px solid v-bind(accentColor);
    outline-offset: -4px;
}
</style>
